export default {"src":"/_next/static/media/urban-sports.69fdc757.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};